import {DeliveryMethodEnum, OrderProviderType, PaymentMethodEnum, StorageKeyEnum} from 'types';
import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

export type OrderActions = {
  resetState: () => void;
  setDeliveryMethod: (method: DeliveryMethodEnum) => void;
  setPaymentMethod: (method: PaymentMethodEnum) => void;
  setTips: (tips: number) => void;
  setCutleryNumber: (number: number) => void;
  setInstructions: (instructions: string) => void;
  setPaymentForSelf: (forSelf: boolean) => void;
  setAnotherPerson: (person: OrderProviderType['another_person']) => void;
  setPreOrder: (preOrder: any) => void;
  setVoucher: (voucher: any) => void;
};

const initialState: OrderProviderType = {
  cutleryNumber: 0,
  instructions: '',
  deliveryMethod: DeliveryMethodEnum.DELIVERY,
  paymentMethod: PaymentMethodEnum.CASH,
  payment_for_self: true,
  tips: 0,
  another_person: {
    name: '',
    phone: '',
  },
  preOrder: undefined,
  voucher: undefined,
};

export type orderStore = OrderProviderType & OrderActions;

/**
|--------------------------------------------------
| useOrderProviderStore
|--------------------------------------------------
*/
export const useOrderProviderStore = create<orderStore>()(
  immer(
    persist(
      (set) => ({
        ...initialState,
        resetState: () => set({...initialState}),
        setDeliveryMethod: (method: DeliveryMethodEnum) =>
          set((state) => {
            state.deliveryMethod = method;
          }),
        setPaymentMethod: (method: PaymentMethodEnum) =>
          set((state) => {
            state.paymentMethod = method;
          }),
        setTips: (tips: number) =>
          set((state) => {
            state.tips = tips;
          }),
        setCutleryNumber: (number: number) =>
          set((state) => {
            state.cutleryNumber = number;
          }),
        setInstructions: (instructions: string) =>
          set((state) => {
            state.instructions = instructions;
          }),
        setPaymentForSelf: (forSelf: boolean) =>
          set((state) => {
            state.payment_for_self = forSelf;
          }),
        setAnotherPerson: (person: OrderProviderType['another_person']) =>
          set((state) => {
            state.another_person = person;
          }),
        setPreOrder: (preOrder: OrderProviderType['preOrder']) =>
          set((state) => {
            state.preOrder = preOrder;
          }),
        setVoucher: (voucher: OrderProviderType['voucher']) =>
          set((state) => {
            state.voucher = voucher;
          }),
      }),
      {
        name: StorageKeyEnum.ORDER,
        partialize: (state) => Object.fromEntries(Object.entries(state).filter(([key]) => ![''].includes(key))),
      },
    ),
  ),
);
